import { Helmet } from 'react-helmet-async';

import { env } from 'env';
import { DEFAULT_SEO, DEFAULT_WEBSITE_NAME } from 'utils';

interface HeadSeoProps {
  title: string;
  description: string;
  icon: string;
  canonicalUrl: string;
  ogTwitterImage: string;
  ogType: string;
  ogImageUrl: string;
  site: string;
  siteName: string;
  children?: React.ReactNode;
}

const HeadSeo = ({
  title,
  description,
  icon,
  canonicalUrl,
  ogTwitterImage,
  ogImageUrl,
  ogType,
  site,
  siteName,
  children,
}: HeadSeoProps): JSX.Element => (
  <Helmet>
    <title>{title && title.length > 0 ? title : DEFAULT_SEO.title}</title>
    <link href={canonicalUrl} rel="canonical" />
    <link href={icon && icon.length > 0 ? icon : DEFAULT_SEO.icon} rel="icon" />

    <meta content="no" name="apple-mobile-web-app-capable" />
    <meta
      content="black-translucent"
      name="apple-mobile-web-app-status-bar-style"
    />
    <meta content="no" name="apple-touch-fullscreen" />
    <meta content="no" name="mobile-web-app-capable" />
    <meta
      content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0,viewport-fit=cover"
      name="viewport"
    />
    <meta content="all" name="robots" />
    <meta
      content={
        description && description.length > 0
          ? description
          : DEFAULT_SEO.description
      }
      name="description"
    />

    <meta content="summary" name="twitter:card" />
    <meta content={site ?? env.service.hubhubWebApp} name="twitter:site" />
    <meta
      content={title && title.length > 0 ? title : DEFAULT_SEO.title}
      name="twitter:title"
    />
    <meta
      content={
        description && description.length > 0
          ? description
          : DEFAULT_SEO.description
      }
      name="twitter:description"
    />
    <meta
      content={
        ogTwitterImage && ogTwitterImage.length > 0
          ? ogTwitterImage
          : DEFAULT_SEO.ogTwitterImage
      }
      name="twitter:image"
    />
    <meta content="vi_VN" property="og:locale" />
    <meta content={siteName ?? DEFAULT_WEBSITE_NAME} property="og:site_name" />
    <meta content={ogType} property="og:type" />
    <meta
      content={title && title.length > 0 ? title : DEFAULT_SEO.title}
      property="og:title"
    />
    <meta
      content={
        description && description.length > 0
          ? description
          : DEFAULT_SEO.description
      }
      property="og:description"
    />
    <meta
      content={
        ogImageUrl && ogImageUrl.length > 0
          ? ogImageUrl
          : DEFAULT_SEO.ogImageUrl
      }
      property="og:image"
    />
    <meta content={canonicalUrl} property="og:url" />
    {children}
  </Helmet>
);

export default HeadSeo;
